<template>
  <div class="d-flex justify-content-center">
    <b-row :class="`mt-3 ${has_slug ? 'col-12 col-sm-10' : 'col-12 col-lg-8 col-xl-5'}`">
      <b-col class="col-12 text-center">
        <h1 class="mb-1">{{ $t('creator.addTitle') }}</h1>
        <p>{{ $t('creator.firstLooking') }}</p>
        <h4 class="text-left mt-2">{{ $t('creator.titleCastingCall') }}</h4>
        <b-form-input :state="title_state" aria-describedby="input-live-help input-live-feedback" v-model="title" class="mt-2" @keyup.enter="title.length > 10 ? save(): ''" :placeholder="$t('creator.titleCastingCallPlaceholder')"></b-form-input>
        <b-form-invalid-feedback id="input-live-feedback" class="text-left">
          <span v-if="title.length <= 10">{{ $t('creator.10characteres') }}</span>
          <span v-else-if="title.length > 65">{{ $t('creator.65characteres') }}</span>
        </b-form-invalid-feedback>

        <b-form-textarea :state="state_description" v-model="casting_call.description" rows="1" max-rows="15" class="mt-2 custom-font" :placeholder="$t('creator.descriptionCasting')" aria-describedby="input-live-help invalid-feedback-description"></b-form-textarea>
        <b-form-invalid-feedback id="invalid-feedback-description" class="text-left">
          <span v-if="casting_call.description && casting_call.description.length <= 10">{{ $t('creator.10characteres') }}</span>
          <span v-else-if="casting_call.description && casting_call.description.length > 2000">{{ $t('creator.2000characters') }}</span>
        </b-form-invalid-feedback>
        <div v-if="showDescriptionHint" class="d-flex align-items-start mt-1 px-1 py-75 rounded description-hint" :class="descriptionShort ? 'hint-ai' : 'hint-saved'">
          <feather-icon :icon="descriptionShort ? 'ZapIcon' : 'CheckCircleIcon'" size="14" class="mt-25 mr-50 flex-shrink-0" />
          <small>{{ descriptionShort ? $t('creator.descriptionAIHint') : $t('creator.descriptionSavedHint') }}</small>
        </div>
        <b-col class="col-12 d-flex justify-content-center">
          <b-button variant="blue-button-next-step" class="blue-button-next-step my-2" :disabled="!state_description || !title_state" @click="onSave">{{has_slug ? $t('creator.savePreview') : $t('creator.butonNext')}}</b-button>
        </b-col>
        <small class="mt-2 w-100 text-center text-muted">{{ $t('creator.requiredCharacters') }}</small>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BFormInput,
  BFormTextarea,
  BFormInvalidFeedback,
} from 'bootstrap-vue';
import utils from '@/libs/utils';
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');
import casting_calls_services from '@/services/casting_calls';

export default {
  name: 'stepTitle',
  components: {
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormInvalidFeedback,
    BFormTextarea,
  },
  data() {
    return {
      title: '',
      profile: {},
      utils,
      steps: null,
      casting_call: {}
    }
  },
  created() {
    this.getData();
  },
  computed: {
    has_slug() {
      return this.$route.params.slug
    },
    title_state() {
      return this.title.length > 10 && this.title.length <= 65;
    },
    state_description() {
      if (this.casting_call.description) return this.casting_call.description.length > 10 && this.casting_call.description.length <= 2000
      else return false
    },
    showDescriptionHint() {
      const len = this.casting_call.description ? this.casting_call.description.length : 0
      return len > 10 && len <= 2000
    },
    descriptionShort() {
      const len = this.casting_call.description ? this.casting_call.description.length : 0
      return len > 10 && len < 200
    },
  },
  methods: {
    showWarningToast({ title, text, showButton = false, textButton = null, onClick = null }) {
      loadToastificationContent().then((module) => {
        this.$toast({
          component: module.default,
          listeners: onClick ? { clickButton: onClick } : {},
          props: {
            title,
            icon: 'AlertTriangleIcon',
            text,
            variant: 'warning',
            showButton,
            textButton,
          },
        });
      });
    },
    onSave() {
      if (!this.steps?.brand && !this.has_slug) {
        this.showWarningToast({
          title: this.$t('campaigns.titleNoBrand'),
          text: this.$t('campaigns.textNoBrand'),
          showButton: true,
          textButton: this.$t('campaigns.goBrands'),
          onClick: this.redirectPreviewBrand,
        });
        return;
      }

      if (!this.title_state) {
        this.showWarningToast({
          title: this.$t('campaigns.titleNoTitle'),
          text: this.$t('campaigns.textNoTitle'),
        });
        return;
      }

      this.save();
    },
    redirectPreviewBrand() {
      this.$router.push({
        name: 'steps_casting_call',
        params: { step: 'organization-search' },
      })
    },
    getData() {
      const step = localStorage.getItem('steps')
      this.steps = step ? JSON.parse(step) : {}

      if (!this.steps?.brand && !this.has_slug) {
        loadToastificationContent().then((module) => {
          this.$toast({
            component: module.default,
            listeners: {
              clickButton: this.redirectPreviewBrand,
            },
            props: {
              title: this.$t('campaigns.titleNoBrand'),
              icon: 'AlertTriangleIcon',
              text: this.$t('campaigns.textNoBrand'),
              variant: 'warning',
              showButton: true,
              textButton: this.$t('campaigns.goBrands'),
            },
          })
        })
      }

      if (this.has_slug) {
        this.casting_call = this.$route.params.casting_call_data;
        this.title = this.casting_call.title;
      } else {
        this.steps = JSON.parse(localStorage.getItem('steps'));
        if (this.steps.title) this.title = this.steps.title;
        if (this.steps.description) this.casting_call.description = this.steps.description;
      }
    },
    setSteps() {
      this.steps.title = this.title;
      this.steps.description = this.casting_call.description;
      localStorage.setItem('steps', JSON.stringify(this.steps));
    },
    save() {
      this.setSteps();
      if (this.has_slug) {
        const form_data = {
          description: this.casting_call.description,
        };
        
        if (this.title !== this.casting_call.title) form_data.title = this.title;

        casting_calls_services.updateCastingCall(this.casting_call.uuid, form_data).then((response) => {
          localStorage.removeItem('steps');
          this.$root.$emit('quit_navbar_white');
          this.$router.push({name: 'view_casting_call', params: {slug: response.response.slug}})
        })
      } else {
        this.$router.push({ name: 'steps_casting_call', params: {step: 'networks'} });
      }
    },
  }
}
</script>
<style scoped>
.description-hint {
  font-size: 0.8rem;
  border: 1px solid;
}
.hint-ai {
  color: #7367f0;
  background-color: rgba(115, 103, 240, 0.08);
  border-color: rgba(115, 103, 240, 0.3) !important;
}
.hint-saved {
  color: #28c76f;
  background-color: rgba(40, 199, 111, 0.08);
  border-color: rgba(40, 199, 111, 0.3) !important;
}
</style>